<div class="inventory-dashboard">
    <page-header
        icon="{{['MENUES', 'INVENTORY'] | monIcons}}"
        header="{{'Site Inventory Summary' | translate}}"
        subHeader="{{ 'List of where all your assets are on the website (i.e. Docs, links, email addresses, code snippet, etc)' | translate }}">
    </page-header>
    <mon-spinner [loading]="isLoading">
        <div class="card panel-monsido-card">
            <mon-panel-header-next [pHeader]="'Inventory History' | translate">
            </mon-panel-header-next>
            <div class="card-body">
                <div class="row" *ngIf="!isLoading">
                    <div class="col-md-48 col-lg-48 col-48 pl-8 pr-10">
                        <mon-chart-line
                            [labels]="labels"
                            [data]="data"
                            [series]="series"
                            [options]="options"
                            [height]="300">
                        </mon-chart-line>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!isLoading">
            <div class="col-48 col-md-24 mb-3">
                <inventory-links-count
                    [notificationList]="technicalList"
                    [panelHeaderTitle]="'Technical' | translate">
                </inventory-links-count>
                <inventory-links-count
                    [notificationList]="contentList"
                    [panelHeaderTitle]="'Content' | translate">
                </inventory-links-count>
            </div>
            <div class="col-48 col-md-24 mb-3 text-center">
                <inventory-links-count
                    [notificationList]="linksList"
                    [panelHeaderTitle]="'Links' | translate">
                </inventory-links-count>
            </div>
        </div>
    </mon-spinner>
</div>
